import emailjs from '@emailjs/browser';

// Configuration EmailJS
// IMPORTANT: Vous devez configurer ces valeurs avec vos propres clés EmailJS
export const EMAIL_CONFIG = {
    SERVICE_ID: 'service_LauraPerillo-1', // À remplacer par votre Service ID EmailJS
    TEMPLATE_ID: 'template_1eqcgmn', // À remplacer par votre Template ID EmailJS
    PUBLIC_KEY: '6CpdoztUKfttUCIwn' // À remplacer par votre Public Key EmailJS
};

// Initialisation d'EmailJS
emailjs.init(EMAIL_CONFIG.PUBLIC_KEY);

// Fonction pour envoyer un email
export const sendContactEmail = async (formData) => {
    try {
        console.log('🚀 Tentative d\'envoi d\'email avec les données:', formData);
        console.log('📝 Configuration utilisée:', {
            SERVICE_ID: EMAIL_CONFIG.SERVICE_ID,
            TEMPLATE_ID: EMAIL_CONFIG.TEMPLATE_ID,
            PUBLIC_KEY: EMAIL_CONFIG.PUBLIC_KEY ? 'Configuré' : 'Manquant'
        });

        const templateParams = {
            from_name: formData.name,
            from_email: formData.email,
            phone: formData.phone,
            subject: formData.subject,
            message: formData.message,
            to_email: 'apattesegales@hotmail.com',
            reply_to: formData.email,
            // Force l'email de destination
            destination_email: 'apattesegales@hotmail.com'
        };

        console.log('📧 Paramètres du template:', templateParams);

        const response = await emailjs.send(
            EMAIL_CONFIG.SERVICE_ID,
            EMAIL_CONFIG.TEMPLATE_ID,
            templateParams
        );

        console.log('✅ Email envoyé avec succès:', response);

        return {
            success: true,
            data: response
        };
    } catch (error) {
        console.error('❌ Erreur lors de l\'envoi de l\'email:', error);
        console.error('📊 Détails de l\'erreur:', {
            message: error.message,
            status: error.status,
            text: error.text
        });

        return {
            success: false,
            error: error.message || 'Erreur inconnue'
        };
    }
};